// @flow

import {
  MACHINES_SUCCESS,
  MACHINES_REQUEST,
  ADD_MACHINE_REQUEST,
  ADD_MACHINE_SUCCESS,
  SERVER_STATUS_SUCCESS,
  SERVER_STATUS_REQUEST,
  NO_OF_REQUEST,
  NO_OF_REQUEST_SUCCESS,
  ALL_LOGS_REQUEST,
  ALL_LOGS_SUCCESS,
  ALERT_LOGS_REQUEST,
  ALERT_LOGS_SUCCESS,
  BILLING_DETAILS_REQUEST,
  BILLING_DETAILS_SUCCESS,
  AUCTION_DETAILS_REQUEST,
  AUCTION_DETAILS_SUCCESS,
  CARD_DETAILS_REQUEST,
  CARD_DETAILS_SUCCESS,
  REPORTS_REQUEST,
  REPORTS_SUCCESS,
  FETCH_CARD_SWAP_LOGS_REQUEST,
  FETCH_CARD_SWAP_LOGS_SUCCESS,
  FETCH_CARD_SWAP_LOGS_FAILURE,
} from '.';

export function fetchMachineRequest(): MachinesRequestActionType {
  return {
    type: MACHINES_REQUEST,
    payload: {},
  };
}

export function fetchMachineSuccess(machines: any): MachinesSuccessActionType {
  return {
    type: MACHINES_SUCCESS,
    payload: { machines },
  };
}

export function fetchReportsRequest(filter: any): ReportsRequestActionType {
  return {
    type: REPORTS_REQUEST,
    payload: { filter },
  };
}

export function fetchReportsSuccess(reports: any): ReportsSuccessActionType {
  return {
    type: REPORTS_SUCCESS,
    payload: { reports },
  };
}

export function addMachineRequest(machine: any): AddMachineRequestActionType {
  return {
    type: ADD_MACHINE_REQUEST,
    payload: { machine },
  };
}

export function addMachineSuccess(machine: any): AddMachineSuccessActionType {
  return {
    type: ADD_MACHINE_SUCCESS,
    payload: { machine },
  };
}

export function fetchServerStatusesRequest(): AddMachineRequestActionType {
  return {
    type: SERVER_STATUS_REQUEST,
    payload: {},
  };
}

export function fetchServerStatusesSuccess(logs: any): AddMachineSuccessActionType {
  return {
    type: SERVER_STATUS_SUCCESS,
    payload: { logs },
  };
}

export function fetchNoOfRequest(): NoOfRequestActionType {
  return {
    type: NO_OF_REQUEST,
    payload: {},
  };
}

export function fetchNoOfRequestSuccess(logs: any): NoOfRequestSuccessActionType {
  return {
    type: NO_OF_REQUEST_SUCCESS,
    payload: { logs },
  };
}

export function fetchAllLogsRequest(logType: string, lotNumber: number): AllLogsRequestActionType {
  return {
    type: ALL_LOGS_REQUEST,
    payload: {
      logType,
      lotNumber,
    },
  };
}

export function fetchAllLogsSuccess(logs: any): AllLogsSuccessActionType {
  return {
    type: ALL_LOGS_SUCCESS,
    payload: { logs },
  };
}

export function fetchBillingDetailsRequest(): BillingDetailsRequestActionType {
  return {
    type: BILLING_DETAILS_REQUEST,
    payload: {},
  };
}

export function fetchBillingDetailsSuccess(billingDetails: any): BillingDetailsSuccessActionType {
  return {
    type: BILLING_DETAILS_SUCCESS,
    payload: { billingDetails },
  };
}

export function fetchAuctionDetailsRequest(): AllLogsRequestActionType {
  return {
    type: AUCTION_DETAILS_REQUEST,
    payload: {},
  };
}

export function fetchAuctionDetailsSuccess(auctionDetails: any): AllLogsSuccessActionType {
  return {
    type: AUCTION_DETAILS_SUCCESS,
    payload: { auctionDetails },
  };
}

export function fetchCardDetailsRequest(): AllLogsRequestActionType {
  return {
    type: CARD_DETAILS_REQUEST,
    payload: {},
  };
}

export function fetchCardDetailsSuccess(cardDetails: any): AllLogsSuccessActionType {
  return {
    type: CARD_DETAILS_SUCCESS,
    payload: { cardDetails },
  };
}

export function fetchAlertLogsRequest(): AllLogsRequestActionType {
  return {
    type: ALERT_LOGS_REQUEST,
    payload: {},
  };
}

export function fetchAlertLogsSuccess(logs: any): AllLogsSuccessActionType {
  return {
    type: ALERT_LOGS_SUCCESS,
    payload: { logs },
  };
}

export function fetchCardSwapLogsRequest(): AllLogsRequestActionType {
  return {
    type: FETCH_CARD_SWAP_LOGS_REQUEST,
    payload: {},
  };
}

export function fetchCardSwapLogsSuccess(logs: any): AllLogsRequestActionType {
  return {
    type: FETCH_CARD_SWAP_LOGS_SUCCESS,
    payload: { logs },
  };
}

export function fetchCardSwapLogsFailure(): AllLogsRequestActionType {
  return {
    type: FETCH_CARD_SWAP_LOGS_FAILURE,
    payload: {},
  };
}
